import { graphql } from '@/gql'

export const createWebhookMutation = graphql(/* GraphQL */ `
  mutation CreateWebhook($input: CreateWebhookInput!) {
    createWebhook(input: $input) {
      ...WebhookFragment
    }
  }
`)

export const updateWebhookMutation = graphql(/* GraphQL */ `
  mutation UpdateWebhook($input: UpdateWebhookInput!) {
    updateWebhook(input: $input) {
      ...WebhookFragment
    }
  }
`)

export const deleteWebhookMutation = graphql(/* GraphQL */ `
  mutation DeleteWebhook($input: DeleteWebhookInput!) {
    deleteWebhook(input: $input) {
      id
    }
  }
`)

export const retryWebhookEventMutation = graphql(/* GraphQL */ `
  mutation RetryWebhookEvent($input: RetryWebhookEventInput!) {
    retryWebhookEvent(input: $input) {
      id
    }
  }
`)
